// Curated collections for diwaligiftsintwodays.com — an express festive gifting
// sub-brand powered by Consortium Gifts. THREE exclusive collections only.
// Images left as elegant shimmer placeholders (image: null) for later swap.
//
// SHOPIFY: to enable live checkout for a product, add its Storefront variant id:
//   variantId: "gid://shopify/ProductVariant/1234567890"
// Products without a variantId fall back to the "connecting soon" message.

export const CATEGORIES = [
  {
    id: "all",
    name: "All Products",
    tagline: "Every festive curation, live from our atelier — express 2-day dispatch across India.",
  },
  {
    id: "boardroom-premium",
    name: "Boardroom Premium",
    tagline: "Executive-grade curations for C-suite leaders, high-value partners & corporate boardrooms.",
  },
  {
    id: "shantanu-nikhil",
    name: "Shantanu & Nikhil Luxury",
    tagline: "Exclusive designer festive curations crafted with India's premier fashion house.",
  },
  {
    id: "festive-express",
    name: "Festive Express Essentials",
    tagline: "High-impact, pre-packed festive hampers ready for immediate 48-hour dispatch.",
  },
];

export const PRODUCTS = [
  // ---- Boardroom Premium Collection ----
  { id: "boardroom-poker-set", name: "Boardroom Poker Chip Set", category: "boardroom-premium", price: 4250, originalPrice: null, badge: "Bestseller", rating: 4.9, image: "https://customer-assets-agu9un31.emergentagent.net/job_diwali-express/artifacts/hgq12r9v_ChatGPT%20Image%20Jul%2028%2C%202026%2C%2004_03_26%20PM.png" },
  { id: "boardroom-wine-set", name: "Boardroom Wine Connoisseur Set", category: "boardroom-premium", price: 1100, originalPrice: null, badge: "Premium", rating: 5.0, image: "https://customer-assets-agu9un31.emergentagent.net/job_diwali-express/artifacts/ongd9ma8_2.png" },
  { id: "boardroom-chess-set", name: "Boardroom Chess Set", category: "boardroom-premium", price: 950, originalPrice: null, badge: null, rating: 4.8, image: "https://customer-assets-agu9un31.emergentagent.net/job_diwali-express/artifacts/3pbv6zkt_4.png" },
  { id: "boardroom-trolley-luggage", name: "Boardroom Foldable Trolley Luggage", category: "boardroom-premium", price: 3500, originalPrice: null, badge: "New", rating: 4.9, image: "https://customer-assets-agu9un31.emergentagent.net/job_diwali-express/artifacts/e6xypblg_3%20%282%29.png" },

  // ---- Shantanu & Nikhil Luxury Collection ----
  { id: "sn-couture-keepsake", name: "Shantanu & Nikhil Luxury Gift Set", category: "shantanu-nikhil", price: 4000, originalPrice: null, badge: "S&N Exclusive", rating: 5.0, image: "https://customer-assets-agu9un31.emergentagent.net/job_diwali-express/artifacts/x8nl81ga_5.png" },
  { id: "regal-heritage-ensemble", name: "Regal Heritage Gift Ensemble", category: "shantanu-nikhil", price: 9999, originalPrice: null, badge: "S&N Exclusive", rating: 5.0, image: null },
  { id: "designer-silk-trousseau", name: "Designer Silk & Sweets Trousseau", category: "shantanu-nikhil", price: 7499, originalPrice: 8299, badge: null, rating: 4.9, image: null },
  { id: "couture-diya-fragrance", name: "Couture Diya & Fragrance Box", category: "shantanu-nikhil", price: 6999, originalPrice: null, badge: "New", rating: 4.8, image: null },

  // ---- Festive Express Essentials ----
  { id: "ready-dry-fruit-hamper", name: "Ready-to-Ship Dry Fruit Hamper", category: "festive-express", price: 1899, originalPrice: 2299, badge: "Bestseller", rating: 4.8, image: null },
  { id: "signature-mithai-choco", name: "Signature Mithai & Chocolate Box", category: "festive-express", price: 1499, originalPrice: null, badge: null, rating: 4.7, image: null },
  { id: "golden-diya-sweets-combo", name: "Golden Diya & Sweets Combo", category: "festive-express", price: 1299, originalPrice: 1599, badge: null, rating: 4.6, image: null },
  { id: "express-delight-basket", name: "Express Festive Delight Basket", category: "festive-express", price: 2199, originalPrice: 2599, badge: "New", rating: 4.8, image: null },
];

export const formatINR = (value) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(value);
